import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus } from "lucide-react";
import { api, messageErreur } from "@/lib/api";

export const TagPastille = ({ tag, actif = true, onClick, testId }) => (
  <button type="button" onClick={onClick} disabled={!onClick} data-testid={testId}
    className="inline-flex items-center gap-1.5 px-3 at-pill text-xs font-bold min-h-[44px]"
    style={{ background: actif ? `color-mix(in srgb, ${tag.couleur} 16%, transparent)` : "var(--surface-2)", color: actif ? tag.couleur : "var(--muted)" }}>
    <span className="w-2 h-2 at-pill" style={{ background: tag.couleur }} />{tag.nom}
  </button>
);

export const ChoixTags = ({ valeur, onChange }) => {
  const [tags, setTags] = useState([]);
  const [nouveau, setNouveau] = useState("");
  const [couleur, setCouleur] = useState("#4A78C2");
  useEffect(() => { api.get("/tags").then((r) => setTags(r.data)); }, []);
  const basculer = (id) => onChange(valeur.includes(id) ? valeur.filter((t) => t !== id) : [...valeur, id]);
  const creer = async () => {
    try { const { data } = await api.post("/tags", { nom: nouveau, couleur }); setTags((t) => [...t.filter((x) => x.id !== data.id), data]); onChange([...valeur, data.id]); setNouveau(""); }
    catch (e) { toast.error(messageErreur(e)); }
  };
  return (
    <div>
      <span className="at-label block mb-1.5">Tags</span>
      <div className="flex flex-wrap gap-1.5 mb-2">{tags.map((t) => <TagPastille key={t.id} tag={t} actif={valeur.includes(t.id)} onClick={() => basculer(t.id)} testId={`tag-toggle-${t.id}`} />)}</div>
      <div className="flex gap-2">
        <input value={nouveau} onChange={(e) => setNouveau(e.target.value)} placeholder="Nouveau tag" className="at-input" data-testid="tag-new-input" />
        <input type="color" value={couleur} onChange={(e) => setCouleur(e.target.value)} className="w-11 h-11 shrink-0 border-0 bg-transparent" aria-label="Couleur du tag" />
        <button type="button" disabled={!nouveau.trim()} onClick={creer} className="at-icon-btn at-btn-ghost shrink-0" aria-label="Créer le tag" data-testid="tag-create-button"><Plus size={17} /></button>
      </div>
    </div>
  );
};
